/* @flow */

import type { RootState, Permissions } from '../types'

export const STATE_KEY: string = 'currentPermissions'

type SetCurrentPermissionsAction = {
  type: 'opinary/SET_CURRENT_PERMISSIONS',
  permissions: Permissions,
}

export function setCurrentPermissions(
  permissions: Permissions
): SetCurrentPermissionsAction {
  return {
    type: 'opinary/SET_CURRENT_PERMISSIONS',
    permissions,
  }
}

type UnsetCurrentPermissionsAction = {
  type: 'opinary/UNSET_CURRENT_PERMISSIONS',
}

export function unsetCurrentPermissions(): UnsetCurrentPermissionsAction {
  return {
    type: 'opinary/UNSET_CURRENT_PERMISSIONS',
  }
}

export function selectCanCreateOneAxis(rootState: RootState): boolean {
  return rootState[STATE_KEY].canCreateOneAxis
}

export function selectCanCreateTwoAxis(rootState: RootState): boolean {
  return rootState[STATE_KEY].canCreateTwoAxis
}

export default function reducer(
  state: ?Permissions = null,
  action: SetCurrentPermissionsAction | UnsetCurrentPermissionsAction
): ?Permissions {
  switch (action.type) {
    case 'opinary/SET_CURRENT_PERMISSIONS':
      return action.permissions
    case 'opinary/UNSET_CURRENT_PERMISSIONS':
      return null
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/currentPermissions.js